import {
  Backdrop,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  GlobalStyles,
  Grid,
  Modal,
  Paper,
  Tooltip,
  Typography,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import React, { useState } from 'react';
import InputField from '../../components/formElements/InputField';

import { LoadingButton } from '@mui/lab';
import { modalstyle } from '../../components/modals/DeletePurchaseMaster';
import PreviewSalesTaxable from '../../components/modals/PreviewSalesTaxable';
import { useThemes } from '../../components/Theme/theme';
import CustomAccordion from '../../components/Accordin/CustomAccordion';
import useMediaQuery from '@mui/material/useMediaQuery';
import { WarningAmber } from '@mui/icons-material';
import ImageUploader from '../../components/formElements/ImageUpload';
import { useInvoiceSettings } from './hooks/useInvoiceSettings';
import InputUpi from './components/InputUpi';
import CheckboxComponent from './components/checkbox';
import CustomTextField from './components/textfield';
import './invoicesettings.css';
const InvoiceSettings = ({ title, top, margin, left }) => {
  const { theme } = useThemes();
  const {
    saveChanges,
    print,
    warningModal,
    previewSalesTaxableModal,
    htmlposTemplete,
    htmlTemplete,
    regular,
    pos,
    Loading,
    ifscLoading,
    RegularSettings,
    PosSettings,
    RegisterationType,
    setRegularSignature,
    handleInput,
    handleInput2,
    handleInputBlur,
    handleInput2Blur,
    handleCheckBox,
    handlePOSCheckBox,
    handleCancel,
    fileUploadInput,
    setPreviewSalesTaxableModal,
    setRegularSettings,
    setPosSignature,
    setPosSettings,
    setwarningModal,
    formatOnBlur,
  } = useInvoiceSettings({ title });
  console.log({ RegularSettings });
  const matches = useMediaQuery(theme.breakpoints.down('lg'));
  const [bool, setBool] = useState(false);

  return matches ? (
    <>
      <Paper
        sx={{
          height: '100px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography variant="body1" color="warning.main" sx={{ fontSize: '13px' }}>
          Available only in desktop view
        </Typography>
        <WarningAmber color="warning" sx={{ fontSize: 18, marginRight: '2px' }} />
      </Paper>
    </>
  ) : (
    <>
      <GlobalStyles
        styles={{
          '.kbody': {
            minHeight: 'auto !important',
          },
        }}
      />
      {Loading && (
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={Loading}>
          <CircularProgress color={'inherit'} />
        </Backdrop>
      )}
      <Box
        sx={{
          paddingBottom: '88px',
          boxSizing: 'content-box',
        }}
      >
        <Box
          sx={{
            minHeight: '550px',
            borderRadius: '10px',
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
          }}
        >
          <Box sx={{}}>
            <Box
              sx={{
                backgroundColor: 'background.paper',
                padding: { xs: '10px', md: '20px' },
                pr: { xs: '5px', md: '' },
                boxShadow: 'rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset',
                borderRadius: '8px',
                display: 'none',
              }}
            >
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: '24px',
                }}
              >
                Invoice Settings
              </Typography>
              <Box sx={{ paddingLeft: '10px' }}>
                <FormControlLabel control={<Checkbox />} label="Enable item-wise entry" />
              </Box>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row-reverse', gap: '10px' }} className={bool == false ? 'disable-interactions' : ''}>
            <Box
              id="regularPreview"
              sx={{
                display: { xs: 'none', lg: 'block' },
                flex: 1,
                backgroundColor: 'white',
                color: 'black',
                borderRadius: '8px',
                border: '1px solid',
              }}
            >
              <div style={{ transform: 'scale(0.9)' }} className="KLOP" dangerouslySetInnerHTML={{ __html: htmlTemplete }} />
              <Box></Box>
            </Box>
            <Paper
              id="regularSettings"
              sx={{
                // backgroundColor: "background.paper",
                padding: { xs: '10px', md: '20px' },

                // boxShadow:
                //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
                border: '1px solid',
                borderRadius: '8px',
                flex: '1',
                height: 'calc( 100vh - 92px)',
                overflowY: 'scroll',
                boxSizing: 'border-box',
                '&::-webkit-scrollbar-track': {
                  background: theme?.palette?.TmId.id.toString().includes('9') ? '#1E1E1E !important' : '',
                },
                '&::-webkit-scrollbar-thumb': {
                  borderColor: theme?.palette?.TmId.id.toString().includes('9') ? '#1E1E1E !important' : '',
                },
              }}
              className="custom-scrollbar"
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: '15px', md: '20px' },
                  paddingBottom: '15px',
                }}
              >
                {title == undefined && 'Invoice Print Template Settings'}
              </Typography>
              <CustomAccordion title="Default Settings">
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: {
                      xs: 'repeat(1,1fr)',
                      sm: 'repeat(1,1fr)',
                      lg: 'repeat(2,1fr)',
                    },
                    // maxWidth: "850px" ,
                    gap: '0px',
                  }}
                >
                  {regular.map((elem, index) => {
                    if (!elem.hide && elem.disabled)
                      return (
                        <CheckboxComponent
                          checked={RegularSettings[elem.key] === 1}
                          disabled={elem.disabled}
                          id={elem.key}
                          label={elem.label}
                          onChange={handleCheckBox}
                          key={elem.key + index}
                        />
                      );
                  })}
                </Box>
              </CustomAccordion>
              <br />
              <Box height="50px" sx={{ display: 'flex', gap: '10px' }}>
                {RegisterationType == 2 && (
                  <Box sx={{ maxWidth: '200px', height: '100%', flex: 1 }}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        lineHeight: '1.0',
                        fontSize: '10px',
                        whiteSpace: 'nowrap',
                        color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : '',
                      }}
                    >
                      {' '}
                      Invoice Heading
                    </Typography>
                    <InputField
                      name="invoiceheading"
                      size="small"
                      type="text"
                      fullWidth
                      InputProps={{
                        style: {
                          height: '40px',
                        },
                      }}
                      onChange={(e) => handleInput(e, 'invoiceheading')}
                      value={RegularSettings.invoiceheading}
                      // Adjust other InputField props as needed
                    />
                  </Box>
                )}
                <Box sx={{ maxWidth: '200px', height: '100%', flex: 1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        lineHeight: '1.0',
                        fontSize: '10px',
                        whiteSpace: 'nowrap',
                        color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : '',
                      }}
                    >
                      {' '}
                      Bos Invoice Heading
                    </Typography>
                    <Tooltip title="This field allows you to customize the heading that appears on your BOS (Bill of Supply) invoices. You can enter any text that will be displayed as the main heading on your BOS invoice documents.">
                      <InfoIcon
                        sx={{
                          fontSize: '10px',
                          color: 'white',
                          backgroundColor: '#1976d2',
                          borderRadius: '50%',
                          cursor: 'pointer',
                        }}
                      />
                    </Tooltip>
                  </Box>
                  <InputField
                    name="bosinvoiceheading"
                    size="small"
                    type="text"
                    fullWidth
                    InputProps={{
                      style: {
                        height: '40px',
                      },
                    }}
                    onChange={(e) => handleInput(e, 'bosinvoiceheading')}
                    value={RegularSettings.bosinvoiceheading}
                  />
                </Box>
                <Box
                  sx={{
                    alignItems: 'flex-end',
                    flex: 1,
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={() =>
                      setPreviewSalesTaxableModal({
                        status: true,
                        type: 'regular',
                      })
                    }
                    sx={{
                      height: '40px',
                      fontSize: { xs: '10px', md: '14px' },
                      display: { xs: 'block', lg: 'none' },
                    }}
                  >
                    View Invoice Preview
                  </Button>
                </Box>
              </Box>
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: {
                    xs: 'repeat(1,1fr)',
                    sm: 'repeat(1,1fr)',
                    lg: 'repeat(2,1fr)',
                  },
                  // maxWidth: "850px" ,
                  gap: '0px',
                }}
              >
                {regular.map((elem, index) => {
                  if (!elem.hide && !elem.disabled)
                    return (
                      <CheckboxComponent
                        checked={RegularSettings[elem.key] === 1}
                        disabled={elem.disabled}
                        id={elem.key}
                        label={elem.label}
                        onChange={handleCheckBox}
                        key={elem.key + index}
                      />
                    );
                })}
              </Box>
              {/* signature */}
              {/* <Box sx={{ display: 'flex', gap: '10px', paddingY: '15px' }}>
                <Box height="" sx={{ display: 'flex', flexDirection: 'column' }}></Box>
              </Box> */}
              <Grid container>
                <Grid item lg={12} xl={12} sx={{ padding: '10px 10px 10px 0' }}>
                  <Box sx={{ padding: '' }}>
                    <FormControl sx={{ width: '100%' }}>
                      <Box sx={{ border: '1px solid #ccc', borderRadius: '4px', p: 2 }}>
                        <CheckboxComponent
                          checked={RegularSettings.companybankdetails === 1}
                          id={'companybankdetails'}
                          label={'Our Bank Details'}
                          onChange={handleCheckBox}
                          sx={{ mb: 2 }}
                        />
                        <Grid container spacing={1}>
                          <Grid item xs={12} md={6}>
                            <Typography
                              sx={{
                                fontWeight: 600,
                                lineHeight: '1.0',
                                fontSize: '10px',
                              }}
                            >
                              {' '}
                              Account Number
                            </Typography>
                            <InputField
                              name="ac_no"
                              maxLength={25}
                              size="small"
                              type="text"
                              inputMode="numeric"
                              fullWidth
                              onChange={(e) => handleInput(e, 'ac_no')}
                              onBlur={(e) => handleInputBlur(e, 'ac_no')}
                              value={RegularSettings.ac_no}
                              error={RegularSettings.errorStatus.ac_no}
                            />
                            {RegularSettings.errorStatus.ac_no && (
                              <Typography sx={{ fontSize: '11px', color: theme.palette.danger.main, mt: 0.5 }}>
                                {RegularSettings.errorFields.ac_no}
                              </Typography>
                            )}
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Typography
                              sx={{
                                fontWeight: 600,
                                lineHeight: '1.0',
                                fontSize: '10px',
                              }}
                            >
                              {' '}
                              IFSC Code
                            </Typography>
                            <InputField
                              maxLength={11}
                              name="ifsc"
                              size="small"
                              type="text"
                              fullWidth
                              InputProps={{
                                endAdornment: ifscLoading ? <CircularProgress size={20} /> : null,
                              }}
                              onChange={(e) => {
                                const value = e.target.value.toUpperCase();
                                handleInput({ target: { name: 'ifsc', value } }, 'ifsc');
                              }}
                              onBlur={(e) => {
                                const value = e.target.value.toUpperCase();
                                handleInputBlur({ target: { name: 'ifsc', value } }, 'ifsc');
                              }}
                              value={RegularSettings.ifsc}
                              error={RegularSettings?.errorStatus?.ifsc}
                            />
                            {RegularSettings?.errorStatus?.ifsc && (
                              <Typography sx={{ fontSize: '11px', color: theme.palette.danger.main, mt: 0.5 }}>
                                {RegularSettings?.errorFields?.ifsc}
                              </Typography>
                            )}
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Typography
                              sx={{
                                fontWeight: 600,
                                lineHeight: '1.0',
                                fontSize: '10px',
                              }}
                            >
                              {' '}
                              Bank Name
                            </Typography>
                            <InputField
                              name="bank_name"
                              maxLength={100}
                              size="small"
                              type="text"
                              fullWidth
                              onChange={(e) => handleInput(e, 'bank_name')}
                              onBlur={(e) => handleInputBlur(e, 'bank_name')}
                              value={RegularSettings.bank_name}
                              error={RegularSettings.errorStatus.bank_name}
                            />
                            {RegularSettings.errorStatus.bank_name && (
                              <Typography sx={{ fontSize: '11px', color: theme.palette.danger.main, mt: 0.5 }}>
                                {RegularSettings.errorFields.bank_name}
                              </Typography>
                            )}
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Typography
                              sx={{
                                fontWeight: 600,
                                lineHeight: '1.0',
                                fontSize: '10px',
                              }}
                            >
                              {' '}
                              Branch
                            </Typography>
                            <InputField
                              maxLength={100}
                              name="branch"
                              size="small"
                              type="text"
                              fullWidth
                              onChange={(e) => handleInput(e, 'branch')}
                              onBlur={(e) => handleInputBlur(e, 'branch')}
                              value={RegularSettings.branch}
                              error={RegularSettings.errorStatus.branch}
                            />
                            {RegularSettings.errorStatus.branch && (
                              <Typography sx={{ fontSize: '11px', color: theme.palette.danger.main, mt: 0.5 }}>
                                {RegularSettings.errorFields.branch}
                              </Typography>
                            )}
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Typography
                              sx={{
                                fontWeight: 600,
                                lineHeight: '1.0',
                                fontSize: '10px',
                              }}
                            >
                              {' '}
                              Account Holder Name
                            </Typography>
                            <InputField
                              maxLength={150}
                              name="ac_name"
                              size="small"
                              type="text"
                              fullWidth
                              onChange={(e) => handleInput(e, 'ac_name')}
                              onBlur={(e) => handleInputBlur(e, 'ac_name')}
                              value={RegularSettings.ac_name}
                              error={RegularSettings.errorStatus.ac_name}
                            />
                            {RegularSettings.errorStatus.ac_name && (
                              <Typography sx={{ fontSize: '11px', color: theme.palette.danger.main, mt: 0.5 }}>
                                {RegularSettings.errorFields.ac_name}
                              </Typography>
                            )}
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Typography
                              sx={{
                                fontWeight: 600,
                                lineHeight: '1.0',
                                fontSize: '10px',
                              }}
                            >
                              {' '}
                              SWIFT Code
                            </Typography>
                            <InputField
                              name="swift_code"
                              size="small"
                              maxLength={11}
                              type="text"
                              fullWidth
                              onChange={(e) => handleInput(e, 'swift_code')}
                              onBlur={(e) => handleInputBlur(e, 'swift_code')}
                              value={RegularSettings.swift_code}
                              error={RegularSettings.errorStatus.swift_code}
                            />
                            {RegularSettings.errorStatus.swift_code && (
                              <Typography sx={{ fontSize: '11px', color: theme.palette.danger.main, mt: 0.5 }}>
                                {RegularSettings.errorFields.swift_code}
                              </Typography>
                            )}
                          </Grid>
                        </Grid>
                      </Box>
                    </FormControl>
                  </Box>
                  <Box sx={{ paddingTop: '10px' }}>
                    <InputUpi
                      name="upi_id"
                      onChange={(e) => {
                        handleInput(e, 'upi_id');
                      }}
                      onBlur={(e) => {
                        handleInputBlur(e, 'upi_id');
                      }}
                      value={RegularSettings?.upi_id}
                      error={RegularSettings?.errorStatus?.upi_id}
                    />
                    {RegularSettings?.errorStatus?.upi_id == true && RegularSettings?.upi_id?.length >= 1 && (
                      <>
                        <Typography style={{ color: theme.palette.danger.main }}>{RegularSettings?.errorFields?.upi_id}</Typography>
                        <Typography style={{ color: theme.palette.info.light }}>Example : ledgerx@ybl</Typography>
                      </>
                    )}
                  </Box>
                </Grid>

                <Grid item lg={12} xl={6} sx={{ width: '100%' }}>
                  <Box sx={{ padding: '10px' }}>
                    <CheckboxComponent
                      checked={RegularSettings.acknowledgementflag === 1}
                      id={'acknowledgementflag'}
                      label={'Acknowledgment'}
                      onChange={handleCheckBox}
                      key={'acknowledgementflag'}
                    />{' '}
                    <Box sx={{}}>
                      <CustomTextField
                        value={RegularSettings.acknowledgement}
                        name="acknowledgement"
                        onChange={handleInput}
                        onBlur={formatOnBlur}
                        multiline
                        max
                        placeholder="Received The Item In Good Condition"
                        rows={4} // Set the number of rows you want to display
                        variant="outlined"
                        maxLength={250}
                      />
                    </Box>
                  </Box>
                </Grid>

                <Grid item px={''} lg={12} xl={6}>
                  <Box sx={{ padding: { xs: '5px 0 0 0', lg: '20px 10px 0 10px' } }}>
                    <ImageUploader
                      value={RegularSettings?.regularinvoicesignaturefilename}
                      onChange={(file) => {
                        console.log(file, 'file');
                        fileUploadInput(file, setRegularSignature);
                        setRegularSettings({
                          ...RegularSettings,
                          regularinvoicesignaturefilename: file ? URL.createObjectURL(file) : '',
                        });
                      }}
                    />
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        lineHeight: '1.0',
                        fontSize: '10px',
                      }}
                    >
                      {' '}
                      Signature Text
                    </Typography>
                    <InputField
                      name="signaturetext"
                      size="small"
                      type="text"
                      fullWidth
                      onChange={(e) => handleInput(e, 'signaturetext')}
                      value={RegularSettings.signaturetext}
                    />
                  </Box>
                </Grid>

                <Grid item lg={12} xl={6} sx={{ width: '100%' }}>
                  <Box sx={{ padding: '10px' }}>
                    {' '}
                    <CheckboxComponent
                      checked={RegularSettings.termsandconditionsflag === 1}
                      id={'termsandconditionsflag'}
                      label={'Terms & Conditions'}
                      onChange={handleCheckBox}
                    />
                    <Box sx={{}}>
                      <CustomTextField
                        value={RegularSettings.termsandcondition}
                        name="termsandcondition"
                        onChange={handleInput}
                        onBlur={formatOnBlur}
                        id="outlined-multiline-flexible"
                        placeholder="Enter Terms & Condition that need to be displayed at the bottom of the invoice"
                        multiline
                        rows={4} // Set the number of rows you want to display
                        variant="outlined"
                        maxLength={250}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid item lg={12} xl={6} sx={{ width: '100%' }}>
                  <Box sx={{ padding: '10px' }}>
                    <CheckboxComponent
                      checked={RegularSettings.declarationatfooterflag === 1}
                      id={'declarationatfooterflag'}
                      label={'Declaration'}
                      onChange={handleCheckBox}
                      key={'declarationatfooterflag'}
                    />{' '}
                    <Box sx={{}}>
                      <CustomTextField
                        value={RegularSettings.declarationatfooter}
                        name="declarationatfooter"
                        onChange={handleInput}
                        onBlur={formatOnBlur}
                        multiline
                        max
                        placeholder="Enter declaration that need to be displayed at the bottom of the invoice"
                        rows={4} // Set the number of rows you want to display
                        variant="outlined"
                        maxLength={250}
                      />
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row-reverse', gap: '10px' }} className={bool == false ? 'disable-interactions' : ''}>
            <Box
              id="posPreview"
              sx={{
                display: { xs: 'none', lg: 'block' },
                flex: 1,
                backgroundColor: 'white',
                color: 'black',
                borderRadius: '8px',
                border: '1px solid',
              }}
            >
              <div style={{ transform: 'scale(0.9)' }} className="KLOP" dangerouslySetInnerHTML={{ __html: htmlposTemplete }} />
            </Box>
            <Paper
              id="posSettings"
              sx={{
                // backgroundColor: "background.paper",
                padding: { xs: '10px', md: '20px' },
                pr: { xs: '5px', md: '' },
                border: '1px solid',
                boxShadow: 'rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset',
                borderRadius: '8px',
                boxSizing: 'border-box',
                overflowY: 'scroll',
                '&::-webkit-scrollbar-track': {
                  background: theme?.palette?.TmId.id.toString().includes('9') ? '#1E1E1E !important' : '',
                },
                '&::-webkit-scrollbar-thumb': {
                  borderColor: theme?.palette?.TmId.id.toString().includes('9') ? '#1E1E1E !important' : '',
                },
              }}
              className="custom-scrollbar"
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: '15px', md: '20px' },
                  paddingBottom: '15px',
                  color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : '',
                }}
              >
                POS Invoice Print Template Settings
              </Typography>
              <CustomAccordion title="Default Settings">
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: {
                      xs: 'repeat(1,1fr)',
                      sm: 'repeat(1,1fr)',
                      lg: 'repeat(2,1fr)',
                    },
                    gap: '0px',
                    // maxWidth: { xs: "unset", sm: "unset", lg: "850px" },
                  }}
                >
                  {pos.map((elem, index) => {
                    if (!elem.hide && elem.disabled) {
                      return (
                        <CheckboxComponent
                          checked={PosSettings[elem.key] === 1}
                          disabled={elem.disabled === true}
                          id={elem.key}
                          label={elem.label}
                          onChange={handlePOSCheckBox}
                          key={elem.key + index}
                        />
                      );
                    }
                  })}
                </Box>
              </CustomAccordion>
              <br />
              <Box height="50px" sx={{ display: 'flex', gap: '10px' }}>
                {RegisterationType == 2 && (
                  <Box sx={{ maxWidth: '200px', height: '100%', flex: 1 }}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        lineHeight: '1.0',
                        fontSize: '10px',
                        color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : '',
                      }}
                    >
                      {' '}
                      Invoice Heading
                    </Typography>
                    <InputField
                      name="invoiceheading"
                      size="small"
                      type="text"
                      fullWidth
                      onChange={handleInput2}
                      value={PosSettings.invoiceheading}
                      // Adjust other InputField props as needed
                    />
                  </Box>
                )}

                <Box sx={{ maxWidth: '200px', height: '100%', flex: 1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        lineHeight: '1.0',
                        fontSize: '10px',
                        whiteSpace: 'nowrap',
                        color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : '',
                      }}
                    >
                      {' '}
                      Bos Invoice Heading
                    </Typography>
                    <Tooltip title="This field allows you to customize the heading that appears on your BOS (Bill of Supply) invoices. You can enter any text that will be displayed as the main heading on your BOS invoice documents.">
                      <InfoIcon
                        sx={{
                          fontSize: '10px',
                          color: 'white',
                          backgroundColor: '#1976d2',
                          borderRadius: '50%',
                          cursor: 'pointer',
                        }}
                      />
                    </Tooltip>
                  </Box>
                  <InputField
                    name="bosinvoiceheading"
                    size="small"
                    type="text"
                    fullWidth
                    InputProps={{
                      style: {
                        height: '40px',
                      },
                    }}
                    onChange={(e) => handleInput2(e, 'bosinvoiceheading')}
                    value={PosSettings.bosinvoiceheading}
                  />
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'flex-end',
                    flex: 1,
                  }}
                >
                  <Button
                    onClick={() => setPreviewSalesTaxableModal({ status: true, type: 'pos' })}
                    variant="outlined"
                    sx={{
                      height: '40px',
                      fontSize: { xs: '10px', md: '14px' },
                      display: { xs: 'block', lg: 'none' },
                    }}
                  >
                    View POS Preview
                  </Button>
                </Box>
              </Box>
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: {
                    xs: 'repeat(1,1fr)',
                    sm: 'repeat(1,1fr)',
                    lg: 'repeat(2,1fr)',
                  },
                  gap: '0px',
                  // maxWidth: { xs: "unset", sm: "unset", lg: "850px" },
                }}
              >
                {pos.map((elem, index) => {
                  if (!elem.hide && !elem.disabled) {
                    return (
                      <CheckboxComponent
                        checked={PosSettings[elem.key] === 1}
                        disabled={elem.disabled === true}
                        id={elem.key}
                        label={elem.label}
                        onChange={handlePOSCheckBox}
                        key={elem.key + index}
                      />
                    );
                  }
                })}
              </Box>

              <Box sx={{ display: 'flex', gap: '10px', paddingY: '15px' }}>
                <Grid container height="" sx={{ display: 'flex', flexDirection: 'row' }}>
                  <Grid item lg={12} pr="10px" xl={6} sx={{ width: '100%' }}>
                    <ImageUploader
                      value={PosSettings?.regularinvoicesignaturefilename}
                      onChange={(file) => {
                        console.log(file, 'file');
                        fileUploadInput(file, setPosSignature);
                        setPosSettings({
                          ...PosSettings,
                          regularinvoicesignaturefilename: file ? URL.createObjectURL(file) : '',
                        });
                      }}
                    />
                  </Grid>
                  <Grid item lg={12} xl={6} sx={{ width: '100%' }}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        lineHeight: '1.0',
                        fontSize: '10px',
                      }}
                    >
                      {' '}
                      Signature Text
                    </Typography>
                    <InputField
                      name="pincode"
                      size="small"
                      type="text"
                      fullWidth
                      onChange={(e) => handleInput2(e, 'signaturetext')}
                      value={PosSettings.signaturetext}
                    />
                  </Grid>
                </Grid>
              </Box>
              <Box sx={{ flex: 1, width: '50%' }}>
                <InputUpi
                  name="upi_id"
                  onChange={(e) => {
                    handleInput2(e, 'upi_id');
                  }}
                  onBlur={(e) => {
                    handleInput2Blur(e, 'upi_id');
                  }}
                  value={PosSettings?.upi_id}
                  error={PosSettings?.errorStatus?.upi_id}
                />

                {PosSettings?.errorStatus?.upi_id == true && PosSettings.upi_id?.length >= 1 && (
                  <>
                    <Typography style={{ color: theme.palette.danger.main }}>{PosSettings?.errorFields?.upi_id}</Typography>
                    <Typography style={{ color: theme.palette.info.light }}>Example : ledgerx@ybl</Typography>
                  </>
                )}
              </Box>
            </Paper>
          </Box>
          <Box
            sx={
              !title
                ? {
                    padding: '20px',
                    display: 'flex',
                    justifyContent: 'end',
                    position: 'fixed',
                    bottom: 0,
                    right: 0,
                    margin: '16px',
                    zIndex: 99,
                  }
                : {
                    display: 'flex',
                    justifyContent: 'end',
                  }
            }
          >
            {bool ? (
              <Tooltip
                arrow
                title={
                  !title && title !== '' ? (
                    <Box display="flex" alignItems="center">
                      <Typography variant="body2" sx={{ fontSize: '11px' }}>
                        Press <kbd>ctrl</kbd> + <kbd>s</kbd>
                      </Typography>
                    </Box>
                  ) : (
                    ''
                  )
                }
              >
                <Button
                  type="button"
                  sx={{ marginRight: '5px' }}
                  variant="contained"
                  onClick={async () => {
                    let result = await saveChanges();
                    if (result) {
                      setBool(false);
                    }
                  }}
                >
                  Save
                </Button>
              </Tooltip>
            ) : (
              <Button variant="contained" onClick={() => setBool(true)} color="primary" sx={{ fontSize: '14px' }}>
                Enable Edit
              </Button>
            )}
            {/* <Button
              type="button"
              variant="outlined"
              sx={{ background: "white", width: "50px" }}
              onClick={() => setwarningModal(true)}
            >
              Cancel
            </Button> */}
          </Box>
        </Box>
      </Box>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={warningModal}
        onClose={() => setwarningModal(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        {/* <Fade in={open}> */}

        <Paper sx={modalstyle}>
          <Box
            sx={{
              borderRadius: '4px',
              padding: '15px',
              textAlign: 'center',
              overflowY: { xs: 'scroll', sm: 'hidden' },
              '.MuiTableCell-root': {
                padding: '10px 10px',
                fontSize: '13px',
              },
            }}
          >
            <Typography
              sx={{
                color: theme?.palette?.TmId.id.toString().includes('9') ? '#FFF1E6' : 'rgb(60 60 60)',
                fontWeight: 'bold',
              }}
            >
              Do you want to cancel?
            </Typography>
          </Box>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: { xs: 'column', sm: 'row' },
              paddingLeft: '15px',
              paddingRight: '15px',
              paddingBottom: '15px',
            }}
          >
            <Button variant="outlined" sx={{ flex: 1, margin: '5px', fontSize: '12px' }} onClick={() => setwarningModal(false)}>
              No
            </Button>
            {/* <Button color="error" onClick={deleteItem} variant='contained' sx={{flex:1,margin:'5px', fontSize : "12px"}} >Yes</Button> */}
            <LoadingButton
              color="error"
              sx={{ flex: 1, margin: '5px', fontSize: '12px' }}
              disableRipple={true}
              variant="contained"
              onClick={() => handleCancel()}
            >
              Yes
            </LoadingButton>
          </Box>
        </Paper>

        {/* </Fade> */}
      </Modal>
      <PreviewSalesTaxable
        open={previewSalesTaxableModal.status}
        setOpen={(value) => setPreviewSalesTaxableModal({ status: value, type: '' })}
        getHtml={print}
      />
    </>
  );
};

export default InvoiceSettings;
